import { useMemo } from "react";
import _ from "lodash";
import { User } from "oidc-client";
import { FeedbackParent } from "../../Feedback/Constants/feedbackEnums";
import { linkSideBarItems, groupSidebarItems, otherSidebarItems } from "../Constants/sideBarItems";
import { SidebarType } from "../Constants/sideBarType";
import { useActiveContext } from "./useActiveContext";
import { useApps } from "../../App/Hooks/useApps";
import { roleService } from "../../Common";
import { Role } from "../../Common/Constants/roleEnums";
import { Company } from "../../Company/Models/Company";

export const useSidebarContents = (type: SidebarType, user?: User, company?: Company) => {
  const { activeApp, activeTopic } = useActiveContext();
  const { loadedApps, appLoadingState } = useApps();

  const isCMAdmin = useMemo(() => {
    return user ? roleService.isUserInRole(user, Role.CMAdmin) : false;
  }, [user]);
  const isAdmin = useMemo(() => {
    return user ? roleService.isUserInRole(user, Role.Admin) || isCMAdmin : false;
  }, [user, isCMAdmin]);

  if (!activeApp && !activeTopic) {
    return [];
  }

  const contextType = activeApp ? FeedbackParent.Application : FeedbackParent.Topic;
  let code = "";
  if (activeApp) code = activeApp.rolePrefix;
  if (activeTopic) code = activeTopic.code;

  if (type === SidebarType.Home) {
    if (!appLoadingState.isLoaded) {
      return [];
    }
    return [
      linkSideBarItems.overview(),
      groupSidebarItems.apps(loadedApps),
      linkSideBarItems.topicsList(),
      linkSideBarItems.tagsList(),
      ...(isAdmin && company ? [linkSideBarItems.companySettings(company)] : [])
    ];
  }

  if (type === SidebarType.App) {
    return [
      otherSidebarItems.contextSelector(),
      linkSideBarItems.appFeatureRequests(code),
      linkSideBarItems.appBugReports(code),
      ...(activeApp?.allowResourceRequest ? [linkSideBarItems.appResourceRequests(code)] : [])
    ];
  }

  if (type === SidebarType.Topic) {
    return [otherSidebarItems.contextSelector(), linkSideBarItems.topicDashboard(code)];
  }

  // return blank sidebar if we have an unexpected type
  return [];
};

export default useSidebarContents;
